module.exports = __webpack_public_path__ + "media/images/flags/ck-c4edebf5831ff71fa3c9a99ceb08f3e7.svg";